export const TicketTypeEnum = Object.freeze({
    EditPlanApproval: 'EDIT_PLAN_APPROVAL',
    HelpAndSupport: 'HELP_AND_SUPPORT'
});
